/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ClaimsInputs */

const en_nav_claims = /** @type {(inputs: Nav_ClaimsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claims`)
};

/**
* | output |
* | --- |
* | "Claims" |
*
* @param {Nav_ClaimsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_claims = /** @type {((inputs?: Nav_ClaimsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ClaimsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_claims(inputs)
});